import { defineStore } from 'pinia'

export const useConfigStore = defineStore('config', {
  state: () => ({
    isLogin: false,
    logoUrl: '/static/images/hdf-logo.png',
    footerImgUrl: '/static/images/home-footer-def.png',
    indexRedmodelDjks: {
      data: '/static/images/index-redmodel-djks.png',
      jumpTo: false,
      jumpType: '',
      url: '',
    },
    indexRedmodelVideo: {
      data: '/static/images/index-redmodel-video.png',
      jumpTo: false,
      jumpType: '',
      url: '',
    },
    payPdfFile: {
        data: null,
        jumpTo: false,
        jumpType: '',
        url: '',
    },
    home365Img: {
      data: '/assets/images/orange-item-center-002.png',
      jumpTo: false,
      jumpType: '',
      url: '',
    },
    noticeList: [],
    infoList: [],
    infos: new Map(),
    infoGroup: {},
    navInfoList: [],
    indexVipCardItems: [],
  }),
  actions: {
    setIsLogin(state) {
      this.isLogin = state
    },
    setLogoUrl(url) {
      this.logoUrl = url
    },
    setFooterImgUrl(url) {
      this.footerImgUrl = url
    },
    setIndexRedmodelDjks(data) {
      this.indexRedmodelDjks = data
    },
    setIndexRedmodelVideo(data) {
      this.indexRedmodelVideo = data
    },
    setNoticeList(list) {
      this.noticeList = list
    },
    setInfoList(list) {
      this.infoList = list
    },
    setInfos(key, info){
        this.infos.set(key, info)
    },
    setInfoGroup(infoGroup){
        this.infoGroup = infoGroup
    },
    setNavInfoList(list){
        this.navInfoList = list
    },
    setPayPdfFile(file){
        this.payPdfFile = file
    },
    setIndexVipCardItems(items){
        this.indexVipCardItems = items
    },
    setHome365Img(img){
        this.home365Img = img
    },
  }
})